import { useQuery } from '@tanstack/react-query'
import { invitationsApi } from '../../services/api'

/** Teacher invitations for one school that have not been accepted yet. */
export function usePendingTeacherInvitations(schoolId?: string, enabled = true) {
  return useQuery({
    // Prefixed with `invitations` so creating, resending or revoking refreshes it.
    queryKey: ['invitations', 'pending-teachers', schoolId],
    queryFn: async () => {
      const rows = await invitationsApi.listInvitations({
        role: 'TEACHER',
        status: 'PENDING',
        school_id: schoolId,
        limit: 100,
      })
      return Array.isArray(rows) ? rows : []
    },
    enabled: enabled && Boolean(schoolId),
    staleTime: 60 * 1000,
  })
}
